<template>
    <div>
        <vx-card class="widget" title="Bonus Action" title-color="black">
            <div>
                <vs-row>
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="pl-0 pr-1 mb-3">
                        <SelectForeign :model.sync="data.share" label="Select by Share" placeholder="Type to Search"
                            :multiple="false" :load_initial="true" :label_keys="['name']" label_class="mb-0"
                            input_class="mt-0 bg-white" :show_id_in_label="false" list_length="10000"
                            :endpoint="$store.state.apiendpoints.share_list" :use_id_as_value="true" :disabled="loading" />
                        <small class="block text-danger mt-1" v-if="api_errors && api_errors.share">
                            {{ api_errors.share.join(', ') }}
                        </small>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="pl-0 pr-1 mb-3">
                        <SelectDate :selectedDate.sync="data.applicable_date" label="Applicable Date"
                            placeholder="Select Date" />
                        <small class="block text-danger mt-1" v-if="api_errors && api_errors.applicable_date">
                            {{ api_errors.applicable_date.join(', ') }}
                        </small>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="pl-0 pr-1 mb-3">
                        <label class="vs-input--label block">Bonus Ratio</label>
                        <vs-row class="mt-1">
                            <vs-col vs-xs="6" vs-sm="6" vs-lg="6" class="pl-0 pr-1">
                                <div class="flex" style="align-items: center">
                                    <vs-input v-model="data.action_info.bonus_ratio.numerator" type="number" min="1"
                                        class="w-full" :disabled="loading" />
                                    &nbsp;&nbsp;<b>:</b>&nbsp;
                                </div>
                                <small class="block text-danger mt-1" v-if="api_errors && api_errors.numerator">
                                    {{ api_errors.numerator.join(', ') }}
                                </small>
                            </vs-col>
                            <vs-col vs-xs="6" vs-sm="6" vs-lg="6" class="pl-1 pr-0">
                                <div class="flex" style="align-items: center">
                                    <vs-input v-model="data.action_info.bonus_ratio.denominator" type="number" min="1"
                                        class="w-full" :disabled="loading" />
                                </div>
                                <small class="block text-danger mt-1" v-if="api_errors && api_errors.denominator">
                                    {{ api_errors.denominator.join(', ') }}
                                </small>
                            </vs-col>
                        </vs-row>
                    </vs-col>
                    <vs-col class="p-0 mb-3">
                        <label class="vs-input--label block mb-1">Round Off Method</label>
                        <ul class="centerx">
                            <vs-col vs-xs="12" vs-sm="3" vs-lg="3">
                                <li>
                                    <vs-radio default v-model="data.action_info.round_off" vs-value="floor">Floor</vs-radio>
                                </li>
                            </vs-col>
                            <vs-col class="pl-0" vs-xs="12" vs-sm="3" vs-lg="3">
                                <li>
                                    <vs-radio v-model="data.action_info.round_off" vs-value="ceil">Ceiling</vs-radio>
                                </li>
                            </vs-col>
                            <vs-col vs-xs="12" vs-sm="3" vs-lg="3">
                                <li>
                                    <vs-radio v-model="data.action_info.round_off" vs-value="round">Round Off</vs-radio>
                                </li>
                            </vs-col>
                        </ul>
                    </vs-col>
                    <vs-col v-if="results.length === 0" vs-xs="12" vs-sm="12" vs-lg="12" class="pl-0 pr-1 mt-3 mb-3">
                        <vs-button class="w-full" @click="load_fifo_data" color="primary" type="filled"
                            :disabled="loading">Show Preview</vs-button>
                    </vs-col>
                    <vs-col v-if="show_preview && results.length > 0" vs-xs="12" vs-sm="12" vs-lg="12"
                        class="pl-0 pr-1 mt-2 mb-3">
                        <vs-table :data="results" class="table-custom">
                            <vs-tr>
                                <vs-th>Portfolio</vs-th>
                                <vs-th style="min-width: 110px;">Available Qty</vs-th>
                                <vs-th style="min-width: 110px;">Bonus Quantity</vs-th>
                            </vs-tr>
                            <template>
                                <template v-for="(item, index) in results">
                                    <vs-tr :key="index">
                                        <vs-td>
                                            {{ item.portfolio_name }}
                                        </vs-td>
                                        <vs-td>
                                            {{ item.left }}
                                        </vs-td>
                                        <vs-td>
                                            <vs-input disabled class="w-full" type="number" min="0"
                                                v-model="item.bonus_quantity" />
                                        </vs-td>
                                    </vs-tr>
                                </template>
                                <template>
                                    <vs-tr>
                                        <vs-td>
                                        </vs-td>
                                        <vs-td>
                                            {{ available_quantity_total }}
                                        </vs-td>
                                        <vs-td>
                                            {{ bonus_quantity_total }}
                                        </vs-td>
                                    </vs-tr>
                                </template>
                            </template>
                        </vs-table>
                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="pl-0 pr-1 mt-3 mb-3">
                            <vs-button class="w-full" @click="save" color="primary" type="filled"
                                :disabled="loading">Submit</vs-button>
                        </vs-col>
                    </vs-col>
                </vs-row>
            </div>
        </vx-card>
    </div>
</template>

<script>
import { Request } from "../../utils/requests";

export default {
    props: {
        embedded_mode: {
            default: false,
        },
        embedded_filters: {
            default: null,
        },
    },
    data() {

        return {
            loading: false,
            data: {
                action_info: {
                    bonus_ratio: {
                        numerator: null,
                        denominator: null
                    },
                    round_off: "floor",
                },
                corporate_action_type: "bonus",
                share: null,
                applicable_date: null,
            },
            api_errors: {},
            available_quantity_total: null,
            bonus_quantity_total: 0,
            results: [],
            show_preview: false
        };
    },
    mounted() {
        this.init()
    },
    watch: {
        '$route.params.bonus_id'(newV) {
            this.init()
        },
        'data.action_info.bonus_ratio.numerator'(newV, oldV) {
            if (newV === oldV) return

            this.bonus_quantity_total = null
            if (this.data.action_info.bonus_ratio.denominator) {
                this.results.forEach(obj => {
                    obj.calculate_bonus_quantity = newV * obj.left / this.data.action_info.bonus_ratio.denominator
                    if (this.data.action_info.round_off == "floor") {
                        obj.bonus_quantity = Math.floor(obj.calculate_bonus_quantity)
                    } else if (this.data.action_info.round_off == "ceil") {
                        obj.bonus_quantity = Math.ceil(obj.calculate_bonus_quantity)
                    } else {
                        obj.bonus_quantity = Math.round(obj.calculate_bonus_quantity)
                    }
                    this.bonus_quantity_total += obj.bonus_quantity
                })
            }

        },
        'data.action_info.bonus_ratio.denominator'(newV, oldV) {
            if (newV === oldV) return

            this.bonus_quantity_total = null
            if (this.data.action_info.bonus_ratio.numerator) {
                this.results.forEach(obj => {
                    obj.calculate_bonus_quantity = this.data.action_info.bonus_ratio.numerator * obj.left / newV
                    if (this.data.action_info.round_off == "floor") {
                        obj.bonus_quantity = Math.floor(obj.calculate_bonus_quantity)
                    } else if (this.data.action_info.round_off == "ceil") {
                        obj.bonus_quantity = Math.ceil(obj.calculate_bonus_quantity)
                    } else {
                        obj.bonus_quantity = Math.round(obj.calculate_bonus_quantity)
                    }
                    this.bonus_quantity_total += obj.bonus_quantity
                })
            }

        },
        'data.share'(newV, oldV) {
            if (newV === oldV) return

            this.results = []
            this.available_quantity_total = null
            this.bonus_quantity_total = null
            // this.show_preview = false

        },
        'data.applicable_date'(newV, oldV) {
            if (newV === oldV) return

            this.results = []
            this.available_quantity_total = null
            this.bonus_quantity_total = null
            // this.show_preview = false
        },
        'data.action_info.round_off'(newV, oldV) {
            if (newV === oldV) return

            this.bonus_quantity_total = null
            this.results.forEach(obj => {
                if (newV == "floor") {
                    obj.bonus_quantity = Math.floor(obj.calculate_bonus_quantity)
                }
                else if (newV == "ceil") {
                    obj.bonus_quantity = Math.ceil(obj.calculate_bonus_quantity)
                }
                else {
                    obj.bonus_quantity = Math.round(obj.calculate_bonus_quantity)
                }
                this.bonus_quantity_total += obj.bonus_quantity
            })
        }
    },
    methods: {
        init() {
            this.bonus_id = this.$route.params.bonus_id
            if (this.$route.params.bonus_id) {
                this.show_preview = true
                this.loadData()
            }
        },
        loadData() {
            this.loading = true

            Request(this, 'GET', this.$store.state.apiendpoints.corporate_action_rud + this.bonus_id + "/").then(
                (res) => {
                    this.show_preview = true
                    this.data = res
                    this.load_fifo_data()
                    this.bonus_id = res.id
                    this.loading = false
                },
                (err) => {
                    this.$vs.notify({
                        time: 2500,
                        title: 'Unknown Error',
                        text: 'An Error Occured. Please Try Again',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                    this.loading = false
                    this.$router.push("/");
                }
            )
        },
        checking_for_required_fields() {

            if (!this.data.share) {
                this.api_errors = {
                    "share": [
                        "Share is required.",
                    ]
                }
                return true
            }
            if (!this.data.applicable_date) {
                this.api_errors = {
                    "applicable_date": [
                        "Applicable Date is required.",
                    ]
                }
                return true
            }

            if (!this.data.action_info.bonus_ratio.numerator) {
                this.api_errors = {
                    "numerator": [
                        "Numerator is required.",
                    ]
                }
                return true
            }
            if (!this.data.action_info.bonus_ratio.denominator) {
                this.api_errors = {
                    "denominator": [
                        "Denominator is required.",
                    ]
                }
                return true
            }

            return false
        },
        save() {
            if (this.checking_for_required_fields()) return
            let $this = this
            let url = $this.$store.state.apiendpoints.corporate_action, request_method = "POST";
            if (this.bonus_id) {
                url = $this.$store.state.apiendpoints.corporate_action_rud + this.bonus_id + "/";
                request_method = "PUT";
            }
            this.submit_disabled = true
            Request($this, request_method, url, null, this.data).then(
                (res) => {
                    $this.$vs.notify({
                        time: 2500,
                        title: 'Saved',
                        text: 'Saved Successfully',
                        iconPack: 'feather',
                        icon: 'icon-check',
                        color: 'success'
                    })
                    this.submit_disabled = false
                    $this.$router.push({ name: 'corporate-action-list' })
                },
                (err) => {
                    if (err.error) {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: 'Please check all fields and Try Again.',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                        this.api_errors = err.error
                    } else {
                        $this.$vs.notify({
                            time: 2500,
                            title: 'Unknown Error',
                            text: 'An Error Occured. Please Try Again',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                    this.submit_disabled = false
                }
            );
        },
        load_fifo_data() {
            // checking for filters
            if (this.checking_for_required_fields()) return
            this.show_preview = true
            let scrip = null
            if (this.data.share.id) {
                scrip = this.data.share.id
            } else {
                scrip = this.data.share
            }
            let url = this.$store.state.apiendpoints.bonus_action;
            let payload = {
                applicable_date: this.data.applicable_date,
                share: scrip
            }
            if (this.bonus_id) {
                payload.bonus_id = this.bonus_id
            }
            console.log(payload);

            this.loading = true;
            this.$vs.loading();

            Request(this, "GET", url, payload).then(
                (res) => {
                    this.results = res.data;
                    if (this.results.length === 0) {
                        this.$vs.notify({
                            time: 3500,
                            title: "No Purchase Found",
                            text: "No Purchase found for this scrip.",
                            iconPack: "feather",
                            icon: "icon-alert-circle",
                            color: "danger",
                        });
                    }
                    this.total_available_quantity()
                    this.calculated_bonus_quantity()
                    this.api_errors = {}
                    this.loading = false;
                    this.$vs.loading.close();
                },
                (err) => {
                    this.$vs.notify({
                        time: 2500,
                        title: "Unknown Error",
                        text: "An Error Occured. Please Try Again",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "danger",
                    });
                    this.api_errors = {}
                    this.loading = false;
                    this.$vs.loading.close();
                }
            );
        },
        total_available_quantity() {
            this.results.forEach(obj => {
                this.available_quantity_total += obj.left
            })
        },
        calculated_bonus_quantity() {
            this.results.forEach(obj => {
                obj.calculate_bonus_quantity = this.data.action_info.bonus_ratio.numerator * obj.left / this.data.action_info.bonus_ratio.denominator
                if (this.data.action_info.round_off == "floor") {
                    obj.bonus_quantity = Math.floor(obj.calculate_bonus_quantity)
                }
                else if (this.data.action_info.round_off == "ceil") {
                    obj.bonus_quantity = Math.ceil(obj.calculate_bonus_quantity)
                }
                else {
                    obj.bonus_quantity = Math.round(obj.calculate_bonus_quantity)
                }
                this.bonus_quantity_total += obj.bonus_quantity
            })
        },
    }
};
</script>